export const messages = {
  en: {
    manualBillGeneration: {
      title: 'Manual Bill Generation',
      mainTitle: 'Manual Bill Generation',
      menuApply: 'Apply',
      menuAudit: 'Bill Audit',
      menuDone: 'Audit Done',
      manageTitle: 'Manual Bill Generation Management',
      detailTitle: 'Application Detail',
      feeType: 'Fee Type',
      feeSubType: 'Fee Sub Type',
      selectFeeType: 'Please select fee type',
      selectFeeSubType: 'Please select fee sub type',
      pleaseSelectFeeType: 'Please select fee type first',
      pleaseSelectFeeSubType: 'Please select fee sub type first',
      feeConfig: 'Fee Item',
      selectFeeConfig: 'Please select fee item',
      billMonth: 'Bill Month',
      selectBillMonth: 'Please select target month',
      search: 'Search',
      searchFail: 'Search failed',
      searchResult: 'Search Results',
      selectAll: 'Select All',
      submitApplication: 'Submit Application',
      submitConfirm: 'Confirm to submit the bill generation application?',
      submitSuccess: 'Application submitted successfully',
      submitFail: 'Submission failed',
      feeName: 'Fee Name',
      roomName: 'Room',
      ownerName: 'Owner',
      curYearMonth: 'Current Period',
      amount: 'Amount',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter application remark',
      applicationName: 'Application Name',
      applicationNamePlaceholder: 'Please enter application name',
      createTimeRange: 'Create Time Range',
      state: 'Status',
      stateWait: 'Pending Audit',
      statePass: 'Approved',
      stateReject: 'Rejected',
      stateGenerated: 'Generated',
      stateFail: 'Generation Failed',
      totalCount: 'Total Count',
      successCount: 'Success Count',
      errorCount: 'Error Count',
      createTime: 'Create Time',
      createUser: 'Creator',
      auditUser: 'Auditor',
      auditTime: 'Audit Time',
      auditRemark: 'Audit Remark',
      auditTitle: 'Audit',
      auditPass: 'Approve',
      auditReject: 'Reject',
      auditPassConfirm: 'Confirm to approve and generate bills?',
      auditRejectConfirm: 'Confirm to reject this application?',
      auditSuccess: 'Audit completed',
      auditFail: 'Audit failed',
      detailList: 'Detail List',
      errorMsg: 'Error Message',
      createNew: 'New Application',
      deleteConfirm: 'Confirm to delete this application?',
      pleaseSelectFeeConfig: 'Please select a fee item',
      pleaseSelectBillMonth: 'Please select a bill month',
      pleaseSelectRecords: 'Please select at least one record',
      pleaseInputRejectReason: 'Please input reject reason'
    }
  },
  zh: {
    manualBillGeneration: {
      title: '账单手工生成',
      mainTitle: '账单手工生成',
      menuApply: '生成申请',
      menuAudit: '账单审核',
      menuDone: '审核完成',
      manageTitle: '账单手工生成管理',
      detailTitle: '申请详情',
      feeType: '费用大类',
      feeSubType: '费用小类',
      selectFeeType: '请选择费用大类',
      selectFeeSubType: '请选择费用小类',
      pleaseSelectFeeType: '请先选择费用大类',
      pleaseSelectFeeSubType: '请先选择费用小类',
      feeConfig: '费用项',
      selectFeeConfig: '请选择费用项',
      billMonth: '账单月份',
      selectBillMonth: '请选择目标账单月份',
      search: '检索',
      searchFail: '检索失败',
      searchResult: '检索结果',
      selectAll: '全选',
      submitApplication: '提交申请',
      submitConfirm: '确认提交账单生成申请？',
      submitSuccess: '申请提交成功',
      submitFail: '提交失败',
      feeName: '费用名称',
      roomName: '房屋',
      ownerName: '业主',
      curYearMonth: '当前账期',
      amount: '预计金额',
      remark: '申请备注',
      remarkPlaceholder: '请输入申请备注',
      applicationName: '申请名称',
      applicationNamePlaceholder: '请输入申请名称',
      createTimeRange: '创建时间段',
      state: '状态',
      stateWait: '待审核',
      statePass: '已通过',
      stateReject: '已驳回',
      stateGenerated: '已生成',
      stateFail: '生成失败',
      totalCount: '总数',
      successCount: '成功数',
      errorCount: '失败数',
      createTime: '创建时间',
      createUser: '创建人',
      auditUser: '审核人',
      auditTime: '审核时间',
      auditRemark: '审核备注',
      auditTitle: '审核操作',
      auditPass: '审核通过',
      auditReject: '审核驳回',
      auditPassConfirm: '确认审核通过并生成账单？',
      auditRejectConfirm: '确认驳回此申请？',
      auditSuccess: '审核完成',
      auditFail: '审核失败',
      detailList: '明细列表',
      errorMsg: '错误信息',
      createNew: '新建申请',
      deleteConfirm: '确认删除此申请？',
      pleaseSelectFeeConfig: '请选择费用项',
      pleaseSelectBillMonth: '请选择账单月份',
      pleaseSelectRecords: '请至少勾选一条记录',
      pleaseInputRejectReason: '驳回时请填写驳回原因'
    }
  },
  'zh-TW': {
    manualBillGeneration: {
      title: '賬單手動生成',
      mainTitle: '賬單手動生成',
      menuApply: '生成申請',
      menuAudit: '賬單審核',
      menuDone: '審核完成',
      manageTitle: '賬單手動生成管理',
      detailTitle: '申請詳情',
      feeType: '費用大類',
      feeSubType: '費用小類',
      selectFeeType: '請選擇費用大類',
      selectFeeSubType: '請選擇費用小類',
      pleaseSelectFeeType: '請先選擇費用大類',
      pleaseSelectFeeSubType: '請先選擇費用小類',
      feeConfig: '費用項',
      selectFeeConfig: '請選擇費用項',
      billMonth: '賬單月份',
      selectBillMonth: '請選擇目標賬單月份',
      search: '檢索',
      searchFail: '檢索失敗',
      searchResult: '檢索結果',
      selectAll: '全選',
      submitApplication: '提交申請',
      submitConfirm: '確認提交賬單生成申請？',
      submitSuccess: '申請提交成功',
      submitFail: '提交失敗',
      feeName: '費用名稱',
      roomName: '房屋',
      ownerName: '業主',
      curYearMonth: '當前賬期',
      amount: '預計金額',
      remark: '申請備註',
      remarkPlaceholder: '請輸入申請備註',
      applicationName: '申請名稱',
      applicationNamePlaceholder: '請輸入申請名稱',
      createTimeRange: '創建時間段',
      state: '狀態',
      stateWait: '待審核',
      statePass: '已通過',
      stateReject: '已駁回',
      stateGenerated: '已生成',
      stateFail: '生成失敗',
      totalCount: '總數',
      successCount: '成功數',
      errorCount: '失敗數',
      createTime: '創建時間',
      createUser: '創建人',
      auditUser: '審核人',
      auditTime: '審核時間',
      auditRemark: '審核備註',
      auditTitle: '審核操作',
      auditPass: '審核通過',
      auditReject: '審核駁回',
      auditPassConfirm: '確認審核通過並生成賬單？',
      auditRejectConfirm: '確認駁回此申請？',
      auditSuccess: '審核完成',
      auditFail: '審核失敗',
      detailList: '明細列表',
      errorMsg: '錯誤信息',
      createNew: '新建申請',
      deleteConfirm: '確認刪除此申請？',
      pleaseSelectFeeConfig: '請選擇費用項',
      pleaseSelectBillMonth: '請選擇賬單月份',
      pleaseSelectRecords: '請至少勾選一條記錄',
      pleaseInputRejectReason: '駁回時請填寫駁回原因'
    }
  }
}
